import { takeLatest } from 'redux-saga/effects';
import { addUserInSaga } from './saga';
import * as actionTypes from './actionTypes';

export default function* watchAddUser() {
    yield takeLatest(actionTypes.ADD_IN_USER, addUserInSaga);
}